import React, { useState } from 'react';
import './Testimonials.css';

const row1 = [
  { initial: 'G', stars: 5, quote: 'Responded quickly and got the job done on time.', name: 'Greg Baker', location: '' },
  { initial: 'J', stars: 5, quote: 'Great friendly service. On time and professional!', name: 'Jessica Welch', location: '' },
  { initial: 'J', quote: "I've used many lawn service companies in recent years, and Fresh Start is certainly the best by far! Will continue to be a customer.", name: 'Jennifer Gary', location: 'Tempe, AZ' },
  { initial: 'C', quote: 'Jen was quick to answer my call and scheduled our project just a few days after we spoke. Communication was excellent and the job was done quickly and precisely in an affordable manner. Thank you — will call you again!', name: 'Cooper Wine', location: 'From Google' },
];

const row2 = [
  { initial: 'P', quote: 'Fresh Start Landscaping did a wonderful job for us as always — they are the VERY BEST! Thank you, Jennifer!!', name: 'Patricia Blick', location: 'Phoenix, AZ' },
  { initial: 'F', quote: 'They showed up on time and completed the work within my budget.', name: 'Fred Brooks', location: 'Scottsdale, AZ' },
  { initial: 'S', quote: 'WOW... what a great experience it was to work with Fresh Start. Everyone was kind and easy to work with. The work ethic was amazing. Whatever they take on they do it with super professionalism. Thank you Jen for such a super experience and for saving my garden.', name: 'Sandra Kaplan', location: 'Tempe, AZ' },
  { initial: 'P', quote: 'Jen and her crew did a great job on our front yard landscaping project. She follows up and always does the right thing. We will use her for our landscaping needs.', name: 'Paula Busk Cross', location: 'Tempe, AZ' },
  { initial: 'S', stars: 5, quote: 'Good, hard-working and knowledgeable crew!', name: 'Steve Novy', location: '' },
  { initial: 'R', stars: 5, quote: `From my first interaction with Jen until she finished my project it has been a pleasure to work with Fresh Start Landscapes. Jen asked great questions about what I wanted to accomplish to understand what was important to me, she was diligent in all her follow up and the work her team did was exactly what we agreed upon. They showed up on time and completed the work within my budget. As someone who owned rental properties and different homes over the years, Fresh Start Landscapes is one of the best landscaping companies I've worked with. I needed both a clean up of my property and help deciding on how to improve the curb appeal of my home, all while keeping it functional for kids. Jen was able to help with each step in the process. She also went the "extra mile" a few times throughout the process. I would HIGHLY recommend Jen and her team!`, name: 'Ryan Picchini', location: '' },
  { initial: 'M', stars: 5, quote: 'Jen and her team have worked on a few things at my house (landscaping, sprinkler system maintenance, snow removal), and have done a great job every time! Her entire team is friendly and kind.', name: 'Melissa Daniels', location: '' },
  { initial: 'M', stars: 5, quote: 'Jennifer and her crew have been very helpful with many projects. They have gone above and beyond to help me get my yard in shape. They seem to be able to do anything I need.', name: 'Mary Roberts', location: '' },
];

const PREVIEW_MAX_CHARS = 280;

const TestimonialCard = ({ initial, stars = 5, quote, name, location }) => {
  const [expanded, setExpanded] = useState(false);
  const isLong = quote.length > PREVIEW_MAX_CHARS;
  const previewText = isLong ? `${quote.slice(0, PREVIEW_MAX_CHARS).trimEnd()}...` : quote;
  const visibleQuote = expanded ? quote : previewText;

  return (
    <div className="t-card">
      <p className="t-card__stars">{'★'.repeat(stars)}</p>
      <p className="t-card__quote">"{visibleQuote}"</p>
      {isLong ? (
        <button
          type="button"
          className="t-card__toggle"
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded ? 'Read less' : 'Read more'}
        </button>
      ) : null}
      <div className="t-card__author">
        <div className="t-card__avatar">{initial}</div>
        <div className="t-card__info">
          <span className="t-card__name">{name}</span>
          {location ? <span className="t-card__location">{location}</span> : null}
        </div>
      </div>
    </div>
  );
};

const Testimonials = () => (
  <section className="testimonials">
    <div className="testimonials__header">
      <span className="testimonials__tag">Client Stories</span>
      <h2 className="testimonials__heading">More time for <span className="testimonials__heading-accent">what matters.</span></h2>
    </div>
    <div className="testimonials__track-wrapper">
      <div className="testimonials__track testimonials__track--left">
        {[...row1, ...row1].map((t, i) => <TestimonialCard key={i} {...t} />)}
      </div>
    </div>
    <div className="testimonials__track-wrapper">
      <div className="testimonials__track testimonials__track--right">
        {[...row2, ...row2].map((t, i) => <TestimonialCard key={i} {...t} />)}
      </div>
    </div>
  </section>
);

export default Testimonials;
